export default function TikTokIcon(props) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 22 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.23005 9.01469V13.0347C7.36005 12.5447 5.45004 13.6547 4.95004 15.5247C4.89004 15.7647 4.85004 16.0147 4.84004 16.2747C4.73004 18.0147 6.05005 19.5147 7.79005 19.6347C7.93005 19.6347 8.07005 19.6347 8.22005 19.6347C9.96005 19.7647 11.47 18.4647 11.6 16.7347C11.61 16.5647 11.61 16.4047 11.6 16.2347V0.304688H15.58C16.26 4.50469 18.36 5.48469 21.17 5.93469V9.96469C19.22 9.80469 17.34 9.17469 15.69 8.11469V16.0747C15.69 19.6747 13.55 23.6947 8.26005 23.6947C4.13005 23.6747 0.810046 20.3147 0.830046 16.1847C0.830046 16.1347 0.830046 16.0847 0.830046 16.0347C0.950046 11.9947 4.33005 8.81469 8.37005 8.93469C8.66005 8.93469 8.95004 8.96469 9.24004 9.01469H9.23005Z"
        fill="inherit"
      />
    </svg>
  )
}
